// Orchard storefront link migration (draft-theme only).
// Rewrites every legacy custom-page product link  /pages/product?f=<slug>
// into the real Shopify product URL  /products/<handle>  — in place, as links
// appear (shop grid, "book this trip" quiz CTA, PDP "more from the orchard",
// footer, anywhere). Changes only href targets; no visual change. Removing the
// <script> include from layout/orchard.liquid fully reverts this.
(function () {
  var MAP = {
    pineapple: 'paradise-pineapple-4-pack',
    tangerine: 'sunshine-tangerine-4-pack',
    cherry: 'wet-wild-cherry-4-pack',
    raspberry: 'radical-raspberry-4-pack',
    mango: 'say-good-night-mango-gummies',
    watermelon: 'wicked-watermelon-gummies',
    berry: 'wild-berry-gummies',
    'mix-pineapple': 'paradise-pineapple-drink-mix',
    'mix-tangerine': 'sunshine-tangerine-drink-mix',
    'mix-cherry': 'wet-wild-cherry-drink-mix',
    'mix-raspberry': 'radical-raspberry-drink-mix'
    // note: zingiez intentionally NOT mapped — it keeps its /pages/zingiez page.
  };

  function handleFor(href) {
    if (!href) return null;
    var m = href.match(/\/pages\/product\?f=([^&#]+)/);
    if (!m) return null;
    var slug;
    try { slug = decodeURIComponent(m[1]); } catch (e) { slug = m[1]; }
    return MAP[slug] || null;
  }

  // On a draft/preview theme, append ?view=orchard so clicking through shows the
  // custom PDP for verification. On the live (main) theme the links stay clean
  // (/products/<handle>) and the assigned product template supplies the look.
  function previewMode() {
    try { return !!(window.Shopify && Shopify.theme && String(Shopify.theme.role || '').toLowerCase() !== 'main'); }
    catch (e) { return false; }
  }
  function target(handle) {
    return previewMode() ? '/products/' + handle + '?view=orchard' : '/products/' + handle;
  }

  // SEO consolidation: when an old /pages/product?f=<slug> URL is hit (from search
  // results, backlinks, bookmarks), declare the real /products/<handle> URL as
  // canonical and forward the visitor there, so authority and indexing converge
  // on the genuine product page instead of being split across the ?f= variants.
  function consolidateLegacy() {
    try {
      if (!/^\/pages\/product\/?$/.test(location.pathname)) return;
      var slug = new URLSearchParams(location.search).get('f');
      if (!slug) return;
      var handle = MAP[slug];
      if (!handle) return;
      var dest = '/products/' + handle;
      var c = document.querySelector('link[rel="canonical"]');
      if (!c) { c = document.createElement('link'); c.setAttribute('rel', 'canonical'); document.head.appendChild(c); }
      c.setAttribute('href', 'https://enterorchard.com' + dest);
      window.location.replace(previewMode() ? dest + '?view=orchard' : dest);
    } catch (e) {}
  }

  function rewrite(a) {
    if (!a || !a.getAttribute) return;
    var handle = handleFor(a.getAttribute('href'));
    if (handle) a.setAttribute('href', target(handle));
  }

  function scan(root) {
    try {
      var as = (root || document).querySelectorAll('a[href*="/pages/product?f="]');
      for (var i = 0; i < as.length; i++) rewrite(as[i]);
    } catch (e) {}
  }

  function boot() {
    scan(document);
    try {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          if (m.type === 'attributes' && m.target && m.target.tagName === 'A') rewrite(m.target);
          if (m.addedNodes) {
            for (var j = 0; j < m.addedNodes.length; j++) {
              var n = m.addedNodes[j];
              if (n.nodeType === 1) { if (n.tagName === 'A') rewrite(n); scan(n); }
            }
          }
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
    } catch (e) {}
  }

  consolidateLegacy();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Click-capture fallback: catches any matching link clicked before the
  // observer has rewritten it (e.g. a freshly-rendered quiz CTA).
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/pages/product?f="]') : null;
    if (!a) return;
    var handle = handleFor(a.getAttribute('href'));
    if (handle) { e.preventDefault(); window.location.href = target(handle); }
  }, true);
})();
